//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiChevronDown,
  mdiChevronUp,
  mdiEye,
  mdiEyeOff,
  mdiPencil,
  mdiReload,
  mdiTableColumn,
} from '@mdi/js'
import user from '~/plugins/user'

export default {
  name: 'HubPage',
  data: () => ({
    crudSelected: [],
    dates: ['2020-01-01'],
    notSupportedAdvanced: 10,
    commandSettingsFirmware: 9.03,
    showAdvanced: false,
    icons: {
      mdiReload,
      mdiTableColumn,
      mdiChevronDown,
      mdiChevronUp,
      mdiPencil,
      mdiEye,
      mdiEyeOff,
    },
    isLoading: false,
    selected: [],
    search: {},
    timeout: null,
    filterTableSearch: '',
    dialog: false,
    dataColumns: {},
    selectedColumns: [],
    headers: [],
    dataItems: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: () => ({
      FirmwareVersion: null,
      GSMName: null,
      GSMUser: null,
      HardwareVersion: null,
      ID: null,
      IMEI: null,
      IMSI: null,
      IPAddress: null,
      IPGateway: null,
      IPNetmask: null,
      LastRequestedAt: null,
      OrganizationID: null,
      OrganizationName: null,
      PhoneToAlerts: { Code: null, Number: null },
      PowerStatus: null,
      PrimaryDNS: null,
      PrimaryServerIP: null,
      PrimaryServerName: null,
      ProxyAddress: null,
      ProxyUsername: null,
      ProxyPassword: null,
      SecondaryDNS: null,
      SecondaryServerIP: null,
      SecondaryServerName: null,
      SerialNumber: null,
      Status: null,
      Type: null,
      VehicleRegistration: null,
      WiFiMode: null,
      WiFiPassword: null,
      WiFiSSID: null,
      ZoneID: null,
      ZoneName: null,
      TextMessage: null,
    }),
    defaultAssignItem: {
      ZoneID: null,
      OrganizationID: null,
      HubIds: null,
    },
    allActive: [],
    allZones: [],
    allWiFiOptions: [],
    allOrganizations: [],
    selectedZone: [],
    selectedWifiMode: [],
    DeleteGlobalError: '',
    GlobalError: '',
    modalAccordionGeneral: [0],
    modalAccordion: [],
    validationErrors: null,
    showPasswords: {
      GSMPassword: false,
      WiFiPassword: false,
      ProxyPassword: false,
    },
    clickTimeout: null,
    userCanModifyHub: false,
    dataItemsFromManyPages: [],
    accordionSections: [
      [
        'AuthKey',
        'SerialNumber',
        'ZoneID',
        'OrganizationID',
        'VehicleRegistration',
      ],
      ['TextMessage'],
      ['GSMName', 'GSMUser', 'PhoneToAlerts', 'Number'],
      ['WiFiMode', 'WiFiPassword', 'WiFiSSID'],
      ['IPAddress', 'IPNetmask', 'IPGateway'],
      ['PrimaryDNS', 'SecondaryDNS'],
      ['ProxyAddress', 'ProxyUsername', 'ProxyPassword'],
      [
        'PrimaryServerIP',
        'PrimaryServerName',
        'SecondaryServerIP',
        'SecondaryServerName',
      ],
    ],
    secondApiUrl: null,
  }),

  computed: {
    dateRangeText() {
      return this.dates.join(' - ')
    },
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    allItemIDs() {
      const ids = []
      this.dataItems.forEach((el) => {
        ids.push(el.ID)
      })
      return ids
    },
  },

  created() {
    this.initTranslations()
    this.$store.commit('layout/setTitle', this.$t('hubs.hubs'))
    this.$root.$refs.HubPage = this

    this.userRoles = localStorage.getItem('userRoles')
    const userRolesObj = JSON.parse(this.userRoles)


        const apiUrls = this.$getApiUrls()
        this.$config.NUXT_API_SECOND_URL = apiUrls.secondApiUrl
        process.env.NUXT_API_BASE_URL = apiUrls.baseApiUrl
        this.secondApiUrl = this.$config.NUXT_API_SECOND_URL + '/hubs'

    this.initTranslations()
    this.showControls = this.$hasPermissions('users', 'modify')
  },

  methods: {
    user,
    // viewHubHistory(action) {
    //   this.$router.push("/hub/status-history","s")
    // },

    initTranslations() {
      this.headers = [
        {
          text: this.$t('hubs.serialNo'),
          align: 'start',
          sortable: true,
          value: 'SerialNumber',
          search: true,
          editable: true,
          forceWidth: '138px',
        },
        {
          text: this.$t('hubs.vehicleRegNo'),
          sortable: true,
          align: 'start',
          value: 'VehicleRegistration',
          search: true,
          icon: 'vehicle',
          forceWidth: '170px',
        },
        {
          text: this.$t('hubs.huHardware'),
          sortable: true,
          align: 'start',
          value: 'HardwareVersion',
          forceWidth: '175px',
        },
        {
          text: this.$t('hubs.huFirmware'),
          sortable: true,
          align: 'start',
          value: 'FirmwareVersion',
          forceWidth: '175px',
        },
        {
          text: this.$t('hubs.connection'),
          align: 'start',
          sortable: true,
          width: '50px',
          value: 'ConnectionStatus',
          statusIcons: true,
          icon: 'settings',
          forceWidth: '66px',
        },
        {
          text: this.$t('hubs_new.status'),
          sortable: true,
          align: 'start',
          value: 'Status',
          dropdown: true,
          dropdownLabel: 'Label',
          dropdownValue: 'Value',
          dependency: 'allActive',
          allItems: [],
          forceWidth: '120px',
          defaultFilter: 'active',
        },
        {
          text: this.$t('hubs.lastSeen'),
          sortable: true,
          align: 'start',
          value: 'LastRequestAt',
          isDateField: true,
          forceWidth: '144px',
        },
        {
          text: this.$t('hubs.type'),
          sortable: true,
          align: 'start',
          value: 'Type',
          search: true,
          forceWidth: '120px',
        },
        {
          text: this.$t('hubs.imei'),
          sortable: true,
          align: 'start',
          value: 'IMEI',
          search: true,
          forceWidth: '168px',
        },
        {
          text: this.$t('hubs.imsi'),
          sortable: true,
          align: 'start',
          value: 'IMSI',
          search: true,
          forceWidth: '168px',
        },
        {
          text: this.$t('hubs.powerStatus'),
          sortable: true,
          align: 'start',
          value: 'PowerStatus',
          forceWidth: '100px',
        },
        {
          text: this.$t('hubs_new.zone'),
          sortable: true,
          align: 'start',
          value: 'ZoneName',
          search: true,
          forceWidth: '184px',
        },
        {
          text: this.$t('hubs.organization'),
          sortable: true,
          align: 'start',
          value: 'OrganizationName',
          search: true,
          forceWidth: '184px',
        },
        {
          text: this.$t('table.actions'),
          align: 'start',
          value: 'Action',
          width: '100px',
          forceWidth: '80px',
          rwdWidth: {
            mobile: '60px',
            desktop: '80px',
          },
        },
      ]
    },

    handleClick(id, serialNumber, vStringSingleClick, vStringDoubleClick) {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout)
        this.clickTimeout = null
        this.processClick(2, id, serialNumber, vStringDoubleClick)
      } else {
        this.clickTimeout = setTimeout(() => {
          this.processClick(1, id, serialNumber, vStringSingleClick)
          this.clickTimeout = null
        }, 300)
      }
    },

    processClick(clickType, id, serialNumber, vString) {
      if (clickType === 1) {
        this.sendData(id, serialNumber, vString)
      } else if (clickType === 2) {
        this.sendData(id, serialNumber, vString)
      }
    },

    async sendJSON(msg, id) {
      await this.$axios
        .put('/hubs/' + id + '/send-amqp-msg/', { Msg: msg })
        .then((resp) => {
          this.$dialog.message.success(this.$t('global.message.success'))
          return resp
        })
        .catch((error) => {
          if (!error.response) {
            return
          }
          if (error.response.data.FieldsError) {
            this.formErrors = error.response.data.FieldsError
          }
          if (error.response.data.GlobalError) {
            this.$refs.childTable.GlobalError = error.response.GlobalError
          }
        })
        .then(() => {
          this.loading = false
        })
    },

    async sendData(id, serialNumber, vString) {
      const serialNumberDec = parseInt(serialNumber, 16)
      const serialNumberString = String(serialNumberDec)
      await this.$axios
        .put('/hubs/' + id + '/send-amqp-msg/', {
          h: serialNumberString,
          v: vString,
        })
        .then((resp) => {
          this.$dialog.message.success(this.$t('global.message.success'))
          return resp
        })
        .catch((error) => {
          if (!error.response) {
            return
          }
          if (error.response.data.FieldsError) {
            this.formErrors = error.response.data.FieldsError
          }
          if (error.response.data.GlobalError) {
            this.$refs.childTable.GlobalError = error.response.GlobalError
          }
        })
        .then(() => {
          this.loading = false
        })
    },

    async changeStatus(status, selected, scope) {
      const data = {
        Status: status,
        HubIds: selected,
        Scope: scope,
      }

      await this.$axios
        .post('/hubs/change-status/', data)
        .then((resp) => {
          this.$dialog.message.success(this.$t('global.message.success'))
          this.filterTable()
          return resp
        })
        .catch((error) => {
          if (!error.response) {
            return
          }
          if (error.response.data.FieldsError) {
            this.formErrors = error.response.data.FieldsError
          }

          if (error.response.data.GlobalError) {
            this.$refs.childTable.GlobalError = error.response.data.GlobalError
          }
        })
        .then(() => {
          this.isLoading = false
        })
    },

    updateDataItems(value) {
      this.dataItems = value
    },

    editItem(item) {
      this.editedIndex = this.dataItems.indexOf(item)
      this.$refs.childModal.editItem(item)
    },

    viewReport(item, isNewTab) {
      const dataItem = {
        page: 'status-history',
        backUrl: this.$route.fullPath,
      }
      this.$store.dispatch('routes/updateBackRoutes', dataItem)
      if (isNewTab === true) {
        window.open(
          `/hub-status-history/report/?id=${item.ID}&RecordingStart=${
            item?.RecordingStartAt ?? ''
          }&RecordingFinish=${item?.RecordingEndAt ?? ''}`,
          '_blank'
        )
      } else {
        this.$router.push(
          `/hub-status-history/report/?id=${item.ID}&RecordingStart=${
            item?.RecordingStartAt ?? ''
          }&RecordingFinish=${item?.RecordingEndAt ?? ''}`
        )
      }
    },

    async filterTable() {
      await this.$refs.childTable.filterTable()
    },

    initFilters(filters) {
      this.allOrganizations = filters.Organizations
      this.allActive = filters.Active
      this.allZones = filters.Zones
      this.allWiFiOptions = filters.WiFiMode

      this.headers.forEach((e) => {
        if ('dependency' in e) {
          e.allItems = this[e.dependency]
        }
      })
    },

    editedItemFromTable(item) {
      return this.editItem(item)
    },

    phoneUpdate(value) {
      this.$refs.childModal.editedItem.PhoneToAlerts = value
    },

    expandAccordionsWithErrors(errors) {
      const accordionErrors = []
      const errorsFieldsNames = Object.keys(errors)

      for (let i = 0; i < this.accordionSections.length; i++) {
        for (let j = 0; j < errorsFieldsNames.length; j++) {
          if (
            (errors[errorsFieldsNames[j]] === true ||
              errors[errorsFieldsNames[j]]?.length) &&
            this.accordionSections[i].includes(errorsFieldsNames[j])
          ) {
            if (i === 0) {
              this.modalAccordionGeneral = [0]
            } else {
              accordionErrors.push(String(Math.max(i - 1, 0)))
            }
            break
          }
        }
      }
      if (accordionErrors.length) {
        this.showAdvanced = true
        this.modalAccordion = Array.from(String(accordionErrors), Number)
      }
    },
    async exportHubs(selected) {
      await this.$axios
        .get('/hubs/0/export-excel/', {
          params: {
            SelectedRows: selected,
            ItemsPerPage: selected.length,
            Page: 1,
          },
        })
        .then((resp) => {
          const file = this.$createBlob(
            resp.data.Result,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          )
          this.$saveAs(file, 'export_hubs.xlsx')
        })
        .catch((error) => {
          if (!error.response) {
            return error
          }

          if (error.response.data.GlobalError) {
            this.$refs.childTable.GlobalError = error.response.data.GlobalError
          }
        })
        .then(() => {
          this.isLoading = false
        })
    },
    checkIfUserCanModifyHub(selectedHubs) {
      const array = []

      if (Array.isArray(selectedHubs)) {
        selectedHubs.forEach((id) => {
          this.dataItems.forEach((item) => {
            if (item.ID === id) {
              const itemExist = this.dataItemsFromManyPages.find(
                (existingItem) => existingItem.ID === item.ID
              )
              if (!itemExist) {
                this.dataItemsFromManyPages.push(item)
              }
            }
          })
        })
      }

      const filteredArray = []

      for (let i = 0; i < this.dataItemsFromManyPages.length; i++) {
        for (let j = 0; j < selectedHubs.length; j++) {
          if (this.dataItemsFromManyPages[i].ID === selectedHubs[j]) {
            filteredArray.push(this.dataItemsFromManyPages[i])
            break
          }
        }
      }

      this.dataItemsFromManyPages = filteredArray

      if (Array.isArray(selectedHubs)) {
        selectedHubs.forEach((id) => {
          let canModify = true
          this.dataItemsFromManyPages.forEach((item) => {
            if (item.ID === id && item.CanModify === false) {
              canModify = false
            }
          })
          array.push(canModify)
        })
      }
      this.userCanModifyHub = !array.includes(false)
    },
  },
}
